export const NAV = {
  brand: 'nav-brand',
  links: {
    home: 'nav-link-home',
    platforms: 'nav-link-platforms',
    solutions: 'nav-link-solutions',
    useCases: 'nav-link-use-cases',
    investments: 'nav-link-investments',
    landscape: 'nav-link-landscape',
    about: 'nav-link-about',
    contact: 'nav-link-contact',
  },
  cta: 'nav-cta-partner',
  mobileToggle: 'nav-mobile-toggle',
};

export const HERO = {
  root: 'hero-root',
  heading: 'hero-heading',
  primaryCta: 'hero-cta-platforms',
  secondaryCta: 'hero-cta-partner',
};

export const PLATFORM_CARD = (slug) => ({
  root: `platform-card-${slug}`,
  visit: `platform-visit-${slug}`,
});

export const LEAD_FORM = {
  root: 'lead-form',
  name: 'lead-input-name',
  email: 'lead-input-email',
  company: 'lead-input-company',
  role: 'lead-input-role',
  interest: 'lead-input-interest',
  message: 'lead-input-message',
  submit: 'lead-submit-button',
  success: 'lead-success-message',
};

export const FOOTER = {
  root: 'site-footer',
};
